import { Button, Divider, Row, Col, Form } from "antd";
import React, { useEffect, useState, useContext } from "react";
import hocFrom from "components/forms/HocFrom";
import Loader from "components/layout/Loader";
import InputControl from "components/inputs/InputControl";
import InputNumber from "components/inputs/InputNumber";
import InputFarsi from "components/inputs/InputFarsi";
import toaster from "helper/toaster";
import DashboardContext from "Context";
import InputControlMulti from "components/inputs/InputControlMulti";
import Mapbox from "components/map/Mapbox";
import axios from "axios";

function AddressForm({
  handleSendWithSimCommand,
  handleUpdateWithSimCommand,
  loding,
  dataUpdate,
  formdata,
  companyId,
  handelLoadingform,
  LoadingForm,
}) {
  const { handelloding, authentication } = useContext(DashboardContext);
  const [form] = Form.useForm();
  const [fields, setFields] = useState({});
  const [visualAddress, setVisualAddress] = useState("");
  const [coordinate, setCoordinate] = useState([35.715298, 51.404343]);

  useEffect(() => {
    handelloding(true);
    setTimeout(() => {
      handelloding(false);
    }, 1000);
    return () => {};
  }, []);

  useEffect(() => {
    if (dataUpdate?.latitude && dataUpdate?.longitude) {
      setCoordinate([dataUpdate?.latitude, dataUpdate?.longitude]);
      setVisualAddress(dataUpdate?.addressName);
      const element = document.getElementById("addressNameTextarea");
      if (element) {
        element.textContent = dataUpdate?.addressName;
      }
    }
  }, [dataUpdate]);

  const onSubmit = (values) => {
    handelLoadingform(true);

    let newFields = {
      servicePointCarCapacity: fields?.servicePointCarCapacity
        ? fields?.servicePointCarCapacity
        : dataUpdate?.servicePointCarCapacity,
      servicePointIds:
        fields?.servicePointIds !== null &&
        fields?.servicePointIds !== undefined &&
        fields?.servicePointIds?.length > 0
          ? fields?.servicePointIds
          : dataUpdate?.servicePointIds,
    };

    const addressFields = {
      ...values,
      latitude: coordinate[0],
      longitude: coordinate[1],
    };

    const command = {
      ...fields,
      addressName:
        fields?.addressName !== null && fields?.addressName !== undefined
          ? fields?.addressName
          : visualAddress ?? dataUpdate?.addressName,
      ...addressFields,
      ...newFields,
      companyId,
      isActive: false,
    };

    const editCommand = {
      ...formdata,
      ...command,
      companyId,
      id: formdata?.addressId,
    };

    if (!command?.addressName && !editCommand?.addressName) {
      handelLoadingform(false);
      return toaster.error("لطفا آدرس را وارد کنید.");
    }

    if (
      (command?.servicePointIds?.length > 0 &&
        !command?.servicePointCarCapacity) ||
      (editCommand?.servicePointIds?.length > 0 &&
        !editCommand?.servicePointCarCapacity)
    ) {
      handelLoadingform(false);
      return toaster.error("لطفا ظرفیت هر ماشین را وارد کنید.");
    }

    delete editCommand?.addressId;

    dataUpdate?.addressId
      ? handleUpdateWithSimCommand(editCommand)
      : handleSendWithSimCommand(command);
    handelLoadingform(false);
  };

  const searchByStats = async (code, type) => {
    const response = await axios.get(
      type === 1
        ? `https://testworkergateway.serviq.net/api/v1/map/getStateGeoLocation?stateId=${code}`
        : `https://testworkergateway.serviq.net/api/v1/map/getCityGeoLocation?cityId=${code}`,
      {
        headers: {
          Authorization: authentication,
          "Content-Type": "application/json; charset=utf-8 ",
        },
      }
    );

    const stats = response?.data?.geoLocation?.center?.id
      ? response?.data?.geoLocation?.center
      : {};
    if (stats?.lat && stats?.lng) {
      setCoordinate([stats?.lat, stats?.lng]);
    }
  };

  return (
    <>
      {loding ? (
        <Loader />
      ) : (
        <Form
          form={form}
          name='form'
          onFinish={onSubmit}
          autoComplete='off'
          layout='vertical'
        >
          <Divider>
            {dataUpdate?.addressId ? "ویرایش آدرس" : "ثبت آدرس جدید"}
          </Divider>
          <Row gutter={20}>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item className='form-group'>
                <InputFarsi
                  label='نام انبار'
                  defaultValue={dataUpdate?.addressKey}
                  name='addressKey'
                  handelValue={(_, value) =>
                    setFields({ ...fields, addressKey: value })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item className='form-group'>
                <InputControl
                  url='/prefix/dropdown'
                  label='پیشوند'
                  name='prefixId'
                  handelValue={(_, value) =>
                    setFields({ ...fields, prefixId: value })
                  }
                  defaultValue={dataUpdate.prefixId}
                />
              </Form.Item>
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item className='form-group'>
                <InputControl
                  url='/personposition/dropdown'
                  name='personPositionId'
                  label='سمت'
                  handelValue={(_, value) =>
                    setFields({ ...fields, personPositionId: value })
                  }
                  defaultValue={dataUpdate?.personPositionId}
                />
              </Form.Item>
            </Col>
            <Col xl={8} lg={8} md={8} sm={24} xs={24}>
              <Form.Item className='form-group'>
                <InputNumber
                  label='شماره ثابت'
                  name='tell'
                  maxLength='8'
                  handelValue={(_, value) =>
                    setFields({ ...fields, tell: value })
                  }
                  defaultValue={dataUpdate?.tell}
                />
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item className='form-group'>
                <InputControlMulti
                  url='/servicePoint/getDropdown'
                  name='servicePointIds'
                  label='نقطه سرویس'
                  handelValue={(_, value) =>
                    setFields({ ...fields, servicePointIds: value })
                  }
                  defaultValue={dataUpdate?.servicePointIds}
                />
              </Form.Item>
            </Col>
            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
              {(fields?.servicePointIds?.length > 0 ||
                dataUpdate?.servicePointIds?.length > 0) && (
                <Form.Item className='form-group'>
                  <InputNumber
                    label='ظرفیت هر ماشین'
                    name='servicePointCarCapacity'
                    defaultValue={dataUpdate?.servicePointCarCapacity}
                    handelValue={(_, value) =>
                      setFields({
                        ...fields,
                        servicePointCarCapacity: parseInt(value),
                      })
                    }
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row gutter={20}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <InputControl
                label='استان'
                name='stateId'
                url='/state/dropdown'
                defaultValue={dataUpdate?.stateId}
                handelValue={(_, value) => {
                  setFields({
                    ...fields,
                    stateId: value,
                    cityId: null,
                    districtId: null,
                  });
                  value && searchByStats(value, 1);
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              {((fields?.stateId !== null && fields?.stateId !== undefined) ||
                (dataUpdate?.stateId !== null &&
                  dataUpdate?.stateId !== undefined)) && (
                <InputControl
                  name='cityId'
                  label='شهر'
                  defaultValue={dataUpdate?.cityId}
                  url={`/city/dropdown/${
                    fields?.stateId !== null && fields?.stateId !== undefined
                      ? fields?.stateId
                      : dataUpdate?.stateId
                  }`}
                  handelValue={(_, value) => {
                    setFields({
                      ...fields,
                      cityId: value,
                      districtId: null,
                    });
                    value && searchByStats(value, 2);
                  }}
                />
              )}
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              {((fields?.cityId !== null && fields?.cityId !== undefined) ||
                (dataUpdate?.cityId !== null &&
                  dataUpdate?.cityId !== undefined)) && (
                <InputControl
                  name='districtId'
                  label='ناحیه'
                  defaultValue={dataUpdate?.districtId}
                  url={`/district/dropdown/${
                    fields?.cityId !== null && fields?.cityId !== undefined
                      ? fields?.cityId
                      : dataUpdate?.cityId
                  }`}
                  handelValue={(_, value) =>
                    setFields({ ...fields, districtId: value })
                  }
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col span={24} className='mb-3'>
              <Mapbox
                coordinate={coordinate}
                setCoordinate={setCoordinate}
                info={{
                  stateId: fields?.stateId || dataUpdate?.stateId,
                  cityId: fields?.cityId || dataUpdate?.cityId,
                }}
                setAddress={(value) => {
                  setVisualAddress(value);
                  const element = document.getElementById(
                    "addressNameTextarea"
                  );
                  if (element) {
                    element.textContent = value;
                  }
                }}
              />
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={24}>
              <Form.Item
                className='form-group'
                rules={[{ required: true, message: "تعریف آدرس الزامی است" }]}
              >
                <label htmlFor='addressNameTextarea'>آدرس</label>
                <textarea
                  className='form-control'
                  id='addressNameTextarea'
                  rows='6'
                  onChange={(e) =>
                    setFields({ ...fields, addressName: e.target.value })
                  }
                ></textarea>
              </Form.Item>
            </Col>
          </Row>
          <Row className='mt-5'>
            <Col>
              <Button
                htmlType='submit'
                className='btn btn-success mr-auto'
                style={{ height: "3rem", width: "10rem" }}
                disabled={LoadingForm}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : (
                  "ثبت"
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
}

export default hocFrom(AddressForm);
